import { gql } from "@apollo/client";
import { VALORACION_ACCESO_INTEGRO_ID, VALORACION_ACCESO_PERMEABLE_ID } from "../../../../Pages/MisVisitasCreation/constants/valoracionAccesoIds";

const SAVE_VISITA_VALORACION_AP = gql`
    mutation saveVisitaPresencialAPValoracion($input: AddVisitaPresencialAPValoracionInput!){
        saveVisitaPresencialAPValoracion(input: $input) {
            idPresencialAP
            idVisita
        }
    }
`;

export default SAVE_VISITA_VALORACION_AP;

export const adaptAddVisitaPresencialAPValoracionInput = (data) => ({
  idPresencialAP: data?.idPresencialAP,
  observacionSitioPuncion: data?.observacionSitioPuncion,
  presenciaEdemas: !!data?.presenciaEdemas,
  permeable: !!data.accesoPermeable,
  integro: !!data.accesoIntegro,
  diuresis: !!data?.diuresis,
  cantidad: data?.cantidad,
  estadoHidratacionOptimo: !!data?.estadoHidratacionOptimo,
  obsHidratacionNo: data?.obsHidratacionNo,
  controlGlucemia: !!data?.controlGlucemia,
  valorGlucemia: data?.valorGlucemia?.toString() || "",
  idVisita: data?.idVisita
});